// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-speed-dial[data-v-07b4dce4]{position:absolute}.v-btn--floating[data-v-07b4dce4]{position:relative}.fondo-app[data-v-07b4dce4]{background-color:#f6f8f9!important}.toolbar-no-menu[data-v-07b4dce4]{background:#f5f5f5!important;box-shadow:0 4px 15px 0 rgba(0,0,0,.09)!important;color:#727891!important;left:0;position:fixed;right:0;z-index:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
